// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LOqn","title":"styles_title__2qXM3"};